/* eslint-disable no-param-reassign */
import * as marietta from '../..';
import { ALMOST_ZERO } from '../Constants';

export default class LineSimplify {
  private static SimplifyInternal(points: marietta.core.Point[], idx1, idx2, threshold, keepers) {
    keepers[idx1] = true;
    keepers[idx2] = true;
    if (idx2 <= idx1 + 1) { return; }
    const point1 = points[idx1];
    const point2 = points[idx2];
    const x1 = point1.x;
    const y1 = point1.y;
    const dx = point2.x - x1;
    const dy = point2.y - y1;
    const lineLengthSquared = dx * dx + dy * dy;

    let maxDist = Number.NEGATIVE_INFINITY; let
      maxDistIdx = -1;
    for (let i = idx1 + 1; i < idx2; i += 1) {
      const pointBetween = points[i];
      const dist = marietta.webcad.util.WebCADUtil.distanceSquaredToLineSegment(x1, y1, dx, dy, lineLengthSquared, pointBetween.x, pointBetween.y);
      if (dist > maxDist) {
        maxDist = dist;
        maxDistIdx = i;
      }
    }
    if (maxDist <= threshold) return;
    this.SimplifyInternal(points, idx1, maxDistIdx, threshold, keepers);
    this.SimplifyInternal(points, maxDistIdx, idx2, threshold, keepers);
  }

  /**
   *
   * @param points //polyline or polygon [{x, y}]
   * @param threshold // maximum distance the simplified line can be from the original
   * @param closed //true -> treates as a closed polygon
   * @returns
   */
  static simplify(points: marietta.core.Point[], threshold, closed = true) {
    let len = points.length;
    threshold = threshold || 0;
    if (len <= 2 || threshold < 0) { return points.slice(0); }

    if (closed) {
      if (marietta.core.Point.distance(points[0], points[points.length - 1]) < ALMOST_ZERO) {
        closed = false;
      } else {
        points = points.slice(0);
        points.push(points[0]);
        len += 1;
      }
    }

    const keepers = [];
    this.SimplifyInternal(points, 0, len - 1, threshold, keepers);
    const out = [];
    for (let i = 0; i < len; i += 1) {
      if (keepers[i]) { out.push(points[i]); }
    }

    if (closed) out.pop();
    return out;
  }
}
